import { useState, useEffect } from 'react'
import Card from '../components/Card'

export default function WordCounter() {
  const [text, setText] = useState('')
  const [stats, setStats] = useState({
    characters: 0,
    words: 0,
    sentences: 0,
    paragraphs: 0,
  })

  useEffect(() => {
    const characters = text.length
    const words = text.trim() ? text.trim().split(/\s+/).length : 0
    const sentences = text.trim() ? text.split(/[.!?]+/).filter(s => s.trim().length > 0).length : 0
    const paragraphs = text.trim() ? text.split(/\n\s*\n/).filter(p => p.trim().length > 0).length : 0

    setStats({ characters, words, sentences, paragraphs })
  }, [text])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="mb-6">
            <label className="label">Text to Analyze:</label>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="input h-40"
              placeholder="Enter your text here..."
            />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-primary-600">{stats.characters}</div>
              <div className="text-sm text-gray-600">Characters</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-primary-600">{stats.words}</div>
              <div className="text-sm text-gray-600">Words</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-primary-600">{stats.sentences}</div>
              <div className="text-sm text-gray-600">Sentences</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-primary-600">{stats.paragraphs}</div>
              <div className="text-sm text-gray-600">Paragraphs</div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

